module.exports = {};


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/core-js/library/modules/_iterators.js
// module id = ../../../../core-js/library/modules/_iterators.js
// module chunks = 42